export default __webpack_public_path__ + "static/media/bike.79a1e10d.png";